export const categories = [
  {
    id: "shoes",
    name: "Shoes",
    namePt: "Tênis",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    count: 820,
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20white%20sneakers%20on%20simple%20cream%20background%20with%20soft%20natural%20window%20light%20from%20left%20side%2C%20elegant%20editorial%20style%2C%20gentle%20shadows%2C%20high%20end%20fashion%20still%20life%2C%20no%20text%20no%20logos%2C%20neutral%20warm%20tones%2C%20clean%20composition%20with%20negative%20space&width=400&height=300&seq=cat-shoes-2026&orientation=landscape",
  },
  {
    id: "hoodies",
    name: "Hoodies/Sweaters",
    namePt: "Moletons/Suéteres",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    count: 450,
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20beige%20oversized%20hoodie%20neatly%20folded%20on%20light%20cream%20surface%2C%20soft%20daylight%20from%20large%20window%2C%20editorial%20fashion%20aesthetic%2C%20gentle%20fabric%20texture%20visible%2C%20warm%20neutral%20palette%2C%20clean%20simple%20composition%2C%20no%20text%20no%20logos%2C%20high%20quality%20commercial%20look&width=400&height=300&seq=cat-hoodies-2026&orientation=landscape",
  },
  {
    id: "tshirts",
    name: "T-Shirts",
    namePt: "Camisetas",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    count: 630,
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20crisp%20white%20cotton%20t-shirt%20draped%20artfully%20on%20light%20cream%20backdrop%2C%20natural%20soft%20lighting%20from%20above%2C%20clean%20editorial%20style%2C%20subtle%20fabric%20wrinkles%2C%20warm%20neutral%20aesthetic%2C%20simple%20composition%2C%20no%20text%20no%20logos%2C%20professional%20commercial%20photography&width=400&height=300&seq=cat-tshirts-2026&orientation=landscape",
  },
  {
    id: "jackets",
    name: "Jackets",
    namePt: "Jaquetas",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-cloud-windy-line",
    count: 380,
    image: "https://readdy.ai/api/search-image?query=Stylish%20minimalist%20product%20photography%20of%20light%20olive%20bomber%20jacket%20hanging%20on%20wooden%20hanger%20against%20cream%20wall%2C%20soft%20natural%20daylight%2C%20editorial%20fashion%20catalog%20style%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20elegant%20simple%20look%2C%20no%20text%20no%20logos%2C%20high%20end%20commercial%20photography&width=400&height=300&seq=cat-jackets-2026&orientation=landscape",
  },
  {
    id: "pants",
    name: "Pants/Shorts",
    namePt: "Calças/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    count: 410,
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20tailored%20beige%20chino%20pants%20neatly%20laid%20flat%20on%20cream%20linen%20surface%2C%20soft%20daylight%20from%20left%2C%20editorial%20fashion%20style%2C%20visible%20fabric%20texture%2C%20warm%20neutral%20aesthetic%2C%20simple%20composition%2C%20no%20text%20no%20logos%2C%20professional%20product%20photography&width=400&height=300&seq=cat-pants-2026&orientation=landscape",
  },
  {
    id: "headwear",
    name: "Headwear",
    namePt: "Chapéus/Bonés",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-customer-service-2-line",
    count: 210,
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20beige%20baseball%20cap%20resting%20on%20cream%20surface%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20fashion%20aesthetic%2C%20clean%20composition%2C%20gentle%20shadows%2C%20warm%20neutral%20tones%2C%20visible%20fabric%20texture%2C%20no%20text%20no%20logos%2C%20high%20quality%20commercial%20photography&width=400&height=300&seq=cat-headwear-2026&orientation=landscape",
  },
  {
    id: "sets",
    name: "Sets",
    namePt: "Conjuntos",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    count: 180,
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20matching%20cream%20sweatshirt%20and%20jogger%20set%20stacked%20neatly%20on%20light%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20fashion%20style%2C%20clean%20aesthetic%2C%20warm%20neutral%20palette%2C%20visible%20fabric%20details%2C%20no%20text%20no%20logos%2C%20professional%20commercial%20photography&width=400&height=300&seq=cat-sets-2026&orientation=landscape",
  },
  {
    id: "underwear",
    name: "Underwear/Underpants",
    namePt: "Roupa Íntima",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-user-heart-line",
    count: 150,
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20soft%20cotton%20underwear%20folded%20neatly%20on%20cream%20linen%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20clean%20editorial%20style%2C%20gentle%20texture%20visible%2C%20warm%20neutral%20aesthetic%2C%20simple%20composition%2C%20no%20text%20no%20logos%2C%20professional%20commercial%20look&width=400&height=300&seq=cat-underwear-2026&orientation=landscape",
  },
  {
    id: "jersey",
    name: "Jersey",
    namePt: "Camisas de Time",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-medal-line",
    count: 290,
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20green%20and%20yellow%20soccer%20jersey%20draped%20elegantly%20on%20cream%20backdrop%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20sports%20fashion%20style%2C%20clean%20composition%2C%20visible%20fabric%20details%2C%20warm%20neutral%20surroundings%2C%20no%20text%20no%20logos%2C%20professional%20commercial%20photography&width=400&height=300&seq=cat-jersey-2026&orientation=landscape",
  },
  {
    id: "accessories",
    name: "Accessories",
    namePt: "Acessórios",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    count: 340,
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20tortoiseshell%20sunglasses%20resting%20on%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20fashion%20aesthetic%2C%20clean%20composition%2C%20gentle%20reflections%20on%20lenses%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%2C%20high%20end%20commercial%20photography&width=400&height=300&seq=cat-accessories-2026&orientation=landscape",
  },
  {
    id: "bags",
    name: "Bags",
    namePt: "Bolsas/Mochilas",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    count: 260,
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20tan%20leather%20backpack%20standing%20on%20cream%20surface%2C%20soft%20natural%20daylight%20from%20left%2C%20editorial%20fashion%20style%2C%20visible%20leather%20texture%2C%20warm%20neutral%20aesthetic%2C%20simple%20composition%2C%20no%20text%20no%20logos%2C%20professional%20commercial%20photography&width=400&height=300&seq=cat-bags-2026&orientation=landscape",
  },
  {
    id: "belts",
    name: "Belts",
    namePt: "Cintos",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    count: 120,
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20brown%20leather%20belt%20coiled%20gracefully%20on%20cream%20surface%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20fashion%20aesthetic%2C%20visible%20leather%20grain%20and%20metal%20buckle%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20professional%20commercial%20photography&width=400&height=300&seq=cat-belts-2026&orientation=landscape",
  },
  {
    id: "perfumes",
    name: "Perfumes",
    namePt: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-flask-line",
    count: 90,
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20amber%20glass%20perfume%20bottle%20on%20cream%20surface%2C%20soft%20natural%20window%20light%20creating%20gentle%20highlights%2C%20editorial%20beauty%20style%2C%20clean%20composition%2C%20warm%20neutral%20aesthetic%2C%20subtle%20shadows%2C%20no%20text%20no%20logos%2C%20high%20end%20commercial%20photography&width=400&height=300&seq=cat-perfumes-2026&orientation=landscape",
  },
  {
    id: "other",
    name: "Other Stuff",
    namePt: "Outros",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    count: 200,
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20assorted%20fashion%20accessories%20including%20wallet%20watch%20and%20keychain%20arranged%20artfully%20on%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20gentle%20shadows%2C%20no%20text%20no%20logos%2C%20professional%20commercial%20photography&width=400&height=300&seq=cat-other-2026&orientation=landscape",
  },
];

export const footerLinks = {
  artigos: [
    { label: "CSSBuy Spreadsheet", slug: "cssbuy-spreadsheet" },
    { label: "CSSBuy é Seguro", slug: "cssbuy-seguro" },
    { label: "CSSBuy Brasil", slug: "cssbuy-brasil" },
    { label: "CSSBuy Yupoo", slug: "cssbuy-yupoo" },
    { label: "CSSBuy Tênis", slug: "cssbuy-tenis" },
    { label: "Melhor Planilha", slug: "melhor-cssbuy-spreadsheet" },
    { label: "Guia Iniciantes", slug: "cssbuy-guia" },
    { label: "Links Verificados", slug: "cssbuy-links" },
    { label: "Roupas Streetwear", slug: "cssbuy-roupas" },
  ],
  roupas: [
    { label: "Camisetas CSSBuy", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
    { label: "Moletons CSSBuy", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
    { label: "Jaquetas CSSBuy", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  ],
  calcados: [
    { label: "Tênis CSSBuy", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { label: "Air Jordan", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { label: "Nike Dunk", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  ],
  acessorios: [
    { label: "Bolsas CSSBuy", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
    { label: "Cintos CSSBuy", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
    { label: "Bonés CSSBuy", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  ],
};